<script setup lang="ts">
// Balance cards widget
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
    <!-- Total Balance Card -->
    <div class="backdrop-blur-xl rounded-3xl p-6 border bg-gradient-to-br from-blue-900/40 to-purple-900/40 border-blue-800/30 transition-all duration-300 hover:border-blue-700/50">
      <div class="flex flex-col gap-4">
        <!-- Icon -->
        <div class="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
          </svg>
        </div>

        <!-- Title and Amount -->
        <div class="flex flex-col gap-2">
          <div class="text-gray-300 text-base font-medium">Total Balance</div>
          <div class="text-white text-3xl font-semibold">€20,100.99</div>
        </div>

        <!-- Top Up Button -->
        <button class="w-full px-4 py-3 bg-white text-gray-900 hover:bg-gray-100 rounded-xl transition-all duration-200 font-medium text-base flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"/>
          </svg>
          Top Up
        </button>
      </div>
    </div>

    <!-- Cash Accounts Card -->
    <div class="backdrop-blur-xl rounded-3xl p-6 border bg-gradient-to-br from-pink-900/30 to-purple-900/30 border-pink-800/20 transition-all duration-300 hover:border-pink-700/40">
      <div class="flex flex-col gap-4">
        <!-- Icon -->
        <div class="w-16 h-16 rounded-2xl bg-gradient-to-br from-pink-400 to-purple-500 flex items-center justify-center">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
          </svg>
        </div>

        <!-- Title and Amount -->
        <div class="flex flex-col gap-2">
          <div class="text-gray-300 text-base font-medium">Cash Accounts</div>
          <div class="text-white text-3xl font-semibold">€20,100.99</div>
        </div>
      </div>
    </div>

    <!-- Crypto Wallets Card -->
    <div class="backdrop-blur-xl rounded-3xl p-6 border bg-gradient-to-br from-purple-900/30 to-blue-900/30 border-purple-800/20 transition-all duration-300 hover:border-purple-700/40">
      <div class="flex flex-col gap-4">
        <!-- Icon -->
        <div class="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center">
          <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M23.638 14.904c-1.602 6.43-8.113 10.34-14.542 8.736C2.67 22.05-1.244 15.525.362 9.105 1.962 2.67 8.475-1.243 14.9.358c6.43 1.605 10.342 8.115 8.738 14.548v-.002zm-6.35-4.613c.24-1.59-.974-2.45-2.64-3.03l.54-2.153-1.315-.33-.525 2.107c-.345-.087-.705-.167-1.064-.25l.526-2.127-1.32-.33-.54 2.165c-.285-.067-.565-.132-.84-.2l-1.815-.45-.35 1.407s.975.225.955.236c.535.136.63.486.615.766l-1.477 5.92c-.075.166-.24.406-.614.314.015.02-.96-.24-.96-.24l-.66 1.51 1.71.426.93.242-.54 2.19 1.32.327.54-2.17c.36.1.705.19 1.05.273l-.51 2.154 1.32.33.545-2.19c2.24.427 3.93.257 4.64-1.774.57-1.637-.03-2.58-1.217-3.196.854-.193 1.5-.76 1.68-1.93h.01zm-3.01 4.22c-.404 1.64-3.157.75-4.05.53l.72-2.9c.896.23 3.757.67 3.33 2.37zm.41-4.24c-.37 1.49-2.662.735-3.405.55l.654-2.64c.744.18 3.137.524 2.75 2.084v.006z"/>
          </svg>
        </div>

        <!-- Title and Amount -->
        <div class="flex flex-col gap-2">
          <div class="text-gray-300 text-base font-medium">Crypto Wallets</div>
          <div class="text-white text-3xl font-semibold">€0.00</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
/* Styles are now handled by Tailwind utility classes */
</style>